module.exports = __webpack_public_path__ + "static/img/sxddyfz.4fef6673.svg";